export default {
  state: {
    billingPayment: {},
    billingPaymentMethod: {},
    billingPaymentMethodEdit: {},
    billingFiscalAuthorizer: {},
    billingFiscalAuthorizerEdit: {}
  },

  getters: {
    getBillingPayment (state) {
      return state.billingPayment
    },

    getBillingPaymentMethod (state) {
      return state.billingPaymentMethod
    },

    getBillingPaymentMethodEdit (state) {
      return state.billingPaymentMethodEdit
    },

    getBillingFiscalAuthorizer (state) {
      return state.billingFiscalAuthorizer
    },

    getBillingFiscalAuthorizerEdit (state) {
      return state.billingFiscalAuthorizerEdit
    }
  },

  mutations: {
    setBillingPayment (state, billingPayment) {
      state.billingPayment = billingPayment
    },

    setBillingPaymentMethod (state, billingPaymentMethod) {
      state.billingPaymentMethod = billingPaymentMethod
    },

    setBillingPaymentMethodEdit (state, billingPaymentMethodEdit) {
      state.billingPaymentMethodEdit = billingPaymentMethodEdit
    },

    setBillingFiscalAuthorizer (state, billingFiscalAuthorizer) {
      state.billingFiscalAuthorizer = billingFiscalAuthorizer
    },

    setBillingFiscalAuthorizerEdit (state, billingFiscalAuthorizerEdit) {
      state.billingFiscalAuthorizerEdit = billingFiscalAuthorizerEdit
    },

    unsetBillingPaymentMethod (state) {
      state.billingPaymentMethod = {}
    }
  }
}
